// @flow @jsx h
import { h } from 'preact'
import { FocusOnEnter } from '../lib/FocusOnEnter'
import type { Question as QuestionType } from '../../types'

type Props = {
  question: QuestionType
}

export const Question = (props: Props) => {
  const { description } = props.question
  return (
    <FocusOnEnter>
      <div>
        <p>{description}</p>
      </div>
    </FocusOnEnter>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/Question.js